<script>
export default {
  functional: true,
  props: {
    // needs to be refactored into two props and fixed accross the site to make eslint happy.
    /*eslint-disable */
    level: [Number, String],
    /*eslint-enable */
    size: {
      type: String,
      default: '',
    },
  },
  render: function(h, context) {
    const baseClass = 'heading';
    const tag = context.props.level ? `h${context.props.level}` : `p`;
    const sizeVariant = context.props.size ? `${baseClass}--${context.props.size.toLowerCase()}` : '';

    context.data.class = [baseClass, sizeVariant, context.data.class].join(' ');

    return h(tag, context.data, context.children);
  },
};
</script>
